<template>
  <van-dialog
    v-bind="$attrs"
    :cancel-button-text="cancelText"
    :confirm-button-text="confirmText"
    :show-cancel-button="(cancelText ? true : false)"
    :show-confirm-button="(confirmText ? true : false)"
    confirm-button-color="#0450B4"
    cancel-button-color="#333A4A"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="nx-dialog-content nx-box-sizing">
      <slot></slot>
    </div>
  </van-dialog>
</template>
<script>
export default {
  name: 'NxDialog',
  props: {
    cancelText: {
      type: [String, Boolean],
      default: () => '取消',
    },
    confirmText: {
      type: [String, Boolean],
      default: () => '确定',
    },
  },
  methods: {
    onCancel() {
      this.$emit('onCancel');
    },
    onConfirm() {
      this.$emit('onConfirm');
    },
  },
};
</script>
<style lang="scss" scoped>
  .nx-dialog-content{
    padding: 24px 20px;

  }
</style>
